import _ from 'underscore';
import dayjs from '../../../shared/services/dayjs.js';
import { schichtenService } from './services/SchichtenService.js';
import { stammdatenService } from './services/StammdatenService.js';
import { datumService } from './services/DatumService.js';
import {
	secureHTML,
	filterSchichtenMitarbeiter,
	findeQualifikation,
	findePosten,
	convertNumberToEuro,
	convertNumberDE,
} from './util.js';
import { erstelleZeitblockTabelle } from './zeitblock.js';
import { Egfz } from '../../../shared/services/Egfz.js';
import SystemDialogService from '../../../shared/services/systemDialogService.js';
import { zeigeKleineNachricht } from './systemNachricht.js';
import { Roles } from '../../../../domain/konstanten/Roles.js';

window.tb = window.tb || {};

// Relevante HTML Elemente auf die oft zugegriffen wird
const gridContent = document.getElementById('grid-content');
const schichtDivTemplate = document.querySelector('[data-schicht-template]');
const schichtPanelTemplate = document.querySelector('[panel-schicht-template]');
const schichtAddenTemplate = document.querySelector('[schicht-adden-template]');
/**
 * Fügt eine neue Zeile im Dienstplan Template hinzu.
 * @param {int} ZeilenID kann MitarbeiterID sein oder ID für die Summenzeile (-1 ist für die TagesSumme)
 * @param {string} postenID für die GesamtSumme wird -1 verwendet.
 * @param {date} datum 
 * @param {array} wunschzeiten
 */
function addGridRow(ZeilenID, postenID, datum, wunschzeiten = [], urlaubsantraege = [], eintrittMA = undefined, austrittMA = undefined, geburtsdatum = undefined) {
	let tagesSummeKlasse = 'tag';
	// Zeile für die Postensumme
	if (ZeilenID === -1 && postenID !== -1) tagesSummeKlasse = 'tages-summe';
	// Zeile für die Tagessummen über alle Posten
	if (ZeilenID === -1 && postenID === -1) tagesSummeKlasse = 'gesamt-tages-summe';
	// Zeilen rendern
	const maNameDiv = document.createElement('div'); // Mitarbeiter Name
	maNameDiv.id = `ma:${`${postenID}:${ZeilenID}`}`;
	maNameDiv.className = `ma grid-element ${tagesSummeKlasse}`;
	maNameDiv.setAttribute('aria-level', postenID);
	gridContent.appendChild(maNameDiv);
	const maStatusDiv = document.createElement('div'); // Mitarbeiter Status
	maStatusDiv.id = `ms:${`${postenID}:${ZeilenID}`}`;
	maStatusDiv.className = `ma grid-element ${tagesSummeKlasse}`;
	maStatusDiv.setAttribute('aria-level', postenID);
	gridContent.appendChild(maStatusDiv);
	const datumStart = dayjs(datum);
	for (let i = 0; i < 7; i += 1) { // Montag - Sonntag
		const tagesDatum = datumStart.add(i, 'days');
		const tagDiv = document.createElement('div');
		let tagMonatKlasse = '';
		if (datum.month() !== tagesDatum.month()) {
			tagMonatKlasse = 'monat-2';
		} else {
			tagMonatKlasse = 'monat-1';
		}
		tagDiv.id = `${i + 1}:${postenID}:${ZeilenID}`;
		tagDiv.className = `${tagMonatKlasse} grid-element ${tagesSummeKlasse}`;
		tagDiv.setAttribute('aria-label', `${tagesDatum.format('DD.MM.YYYY')}`);
		tagDiv.setAttribute('aria-level', postenID);
		const dateString = tagesDatum.format('YYYY-MM-DD');
		// wunschzeitraum anzeigen
		if (!_.isEmpty(wunschzeiten)) {
			const wunschtag = wunschzeiten.find((wz) => {
				return dateString >= wz.ZeitraumVon && dateString <= wz.ZeitraumBis;
			});
			if (!_.isEmpty(wunschtag)) {
				wunschtag.ZeitraumPositiv ? tagDiv.classList.add('wunschzeit-positiv') : tagDiv.classList.add('wunschzeit-negativ');
				tagDiv.title = wunschtag.ZeitraumNotiz;
			}
		}
		// Urlaub anzeigen (verhindert schicht hinzufügen)
		if (!_.isEmpty(urlaubsantraege)) {
			const hatUrlaub = urlaubsantraege.some((ua) => {
				return ua.UrlaubStatus === 'genehmigt' && dateString >= ua.UrlaubVon && dateString <= ua.UrlaubBis;
			});
			if (hatUrlaub) {
				const urlaubIcon = document.createElement('i');
				urlaubIcon.className = 'bi bi-airplane-fill tag-urlaub';
				urlaubIcon.title = 'Die Person ist im Urlaub!';
				tagDiv.appendChild(urlaubIcon);
			}
		}
		// Falls es ein ein-/austrittsdatum gibt, können wir das anzeigen...
		if ((eintrittMA && tagesDatum.format('YYYY-MM-DD') < eintrittMA) || (austrittMA && tagesDatum.format('YYYY-MM-DD') > austrittMA)) {
			tagDiv.classList.add('ma-inaktiv');
		}
		// Falls es ein geburtsdatum gibt, können wir den geburtstag anzeigen...
		if (geburtsdatum) {
			const [yG, mG, dG] = geburtsdatum.split('-').map(Number);
			const [yD, mD, dD] = tagesDatum.format('YYYY-MM-DD').split('-').map(Number);
			if (mG === mD && dG === dD) {
				const geburtstagIcon = document.createElement('i');
				geburtstagIcon.className = 'bi bi-cake2-fill tag-geburtstag';
				geburtstagIcon.title = 'Die Person hat heute Geburtstag.';
				tagDiv.appendChild(geburtstagIcon);
				tagDiv.style.backgroundColor = 'var(--custom-light-pink)';
				tagDiv.title = (tagDiv.title + ' Die Person hat heute Geburtstag.').trim();
			}
		}
		gridContent.appendChild(tagDiv);
	}
	const maSummeDiv = document.createElement('div'); // Mitarbeiter Summe
	maSummeDiv.className = `ge grid-element ${tagesSummeKlasse}`;
	maSummeDiv.id = `ge:${`${postenID}:${ZeilenID}`}`;
	maSummeDiv.setAttribute('aria-level', postenID);
	gridContent.appendChild(maSummeDiv);
}

/**
 * Fügt eine Headerzeile für den Posten hinzu
 * @param {string} postenID
 * @param {array} posten Liste der Postene
 */
function addHeaderRow(postenID, posten = []) {
	const template = document.querySelector('[area-header-template]');
	const neueZeile = template.content.cloneNode(true).children[0];
	neueZeile.id = `${postenID}-header`;
	neueZeile.querySelector('[area-header-title]').innerText = posten.find((b) => b._id === postenID).Posten.toUpperCase();
	// Button config für mitarbeiter auswahl
	const auswahlButton = neueZeile.querySelector('[area-header-auswahl]');
	auswahlButton.id = `${postenID}-auswahl`;
	auswahlButton.addEventListener('click', (event) => {
		event.stopPropagation();
		window.tb.mitarbeiterAuswahlPosten(postenID);
	});
	// Button config für Posten Freigabe
	const freigabeButton = neueZeile.querySelector('[area-header-freigabe]');
	freigabeButton.id = `${postenID}-freigabe`;
	freigabeButton.addEventListener('click', (event) => {
		event.stopPropagation();
		window.tb.schichtenFreigebenWoche(postenID);
	});
	gridContent.appendChild(neueZeile);
}

/**
 * Füllt den Bereich HTML Select mit den verfügbaren Bereichen
 * @param {array} bereiche Liste der Posten
 */
function fuelleBereichSelect(bereiche = []) {
	const bereichSelect = document.getElementById('bereich-select');
	bereichSelect.innerHTML = '';
	bereiche.forEach((b) => {
		const newOption = document.createElement('option');
		newOption.setAttribute('value', b.BereichID);
		newOption.innerText = b.Bereich;
		newOption.value = b._id;
		bereichSelect.appendChild(newOption);
	});
}

/**
 * Befüllt den Dienstplan mit allen Daten und Controls
 * @param {boolean} initialised boolean ob der Dienstplan schonmal erzeugt wurde, meistens true
 * @param {boolean} betriebWechsel boolean ob die Stammdaten Posten & Mitarbeiter neugeladen werden soll
 * @param {boolean} bereichWechsel boolean ob ein anderer Bereich geladen werden sollen
 * @param {boolean} maRefresh boolean ob die Mitarbeiter neugeladen werden sollen
 */
 async function zeigeDienstplan(initialised = true, betriebWechsel = false, bereichWechsel = false, maRefresh = false) {
	// resetten des grids
	gridContent.innerHTML = '';
	gridContent.style.display = 'none';
	document.body.style.cursor = 'wait';
	// Die Kopierquelle-Vorschau lebt außerhalb von #grid-content und bleibt deshalb
	// über Wochen-/Bereich-/Betriebswechsel hinweg sichtbar. Nichts zu tun hier.
	// laden aller relevanten Daten (die aktuelle betriebsstätteID wird aus dem stammdatenService geladen)
	const postenListe = await stammdatenService.getPosten(betriebWechsel);
	const mitarbeiterliste = await stammdatenService.getMitarbeiter(betriebWechsel || maRefresh);
	const mitarbeiterAktiv = filterMitarbeiterAktiv(mitarbeiterliste);
	const qualifikationen = await stammdatenService.getQualifikationen();
	const unternehmen = await stammdatenService.getUnternehmensdaten();
	unternehmen.Bereiche.sort((a, b) => a.Bereich.localeCompare(b.Bereich));
	const bereicheAktiv = unternehmen.Bereiche.filter((bereich) => bereich.Verwenden);
	const bereichePostenAktiv = bereicheAktiv.filter((bereich) => postenListe.some((posten) => _.isEqual(posten.BereichID, bereich._id)));
	if (!initialised) {
		fuelleBereichSelect(bereichePostenAktiv);
	}
	// Falls es schon ein Vorlagenselect gibt, erstellen wir ein neues bei einem Betriebswechsel, Bereichwechsel oder Initialisierung
	if (betriebWechsel || !initialised || bereichWechsel) {
		await erstelleToolbarVorlagenSelect();
	}
	initialised = true;

	// bereichAuswahl Bereich, der angezeigt werden soll, es muss immer ein Bereich ausgewählt sein
	const bereichAuswahl = document.getElementById('bereich-select').value;
	if (bereichAuswahl !== '') {
		// Lade alle Schichten des Bereichs...
		const alleSchichten = await schichtenService.getSchichten(datumService.laufendesDatum);
		// Einmalig: Map<MitarbeiterID → Set<PostenID>> aus den Schichten aufbauen
		const schichtenPostenByMA = new Map();
		for (const s of alleSchichten) {
			if (!schichtenPostenByMA.has(s.MitarbeiterID)) schichtenPostenByMA.set(s.MitarbeiterID, new Set());
			schichtenPostenByMA.get(s.MitarbeiterID).add(s.PostenID);
		}
		// Zuerst alle Posten des Bereichs herausfiltern...
		const postenInBereich = postenListe.filter((po) => po.BereichID === bereichAuswahl);
		for (const posten of postenInBereich) {
			// Posten pro Posten die Schichten anzeigen...
			const postenSchichten = alleSchichten.filter((s) => s.PostenID === posten._id);
			// hier werden die Zeilen der Mitarbeiter erstellt pro Posten...
			zeigePostenZeilen(postenListe, posten, mitarbeiterAktiv, schichtenPostenByMA);
			zeigeSchichten(alleSchichten, posten, postenListe);
			// Nur der DienstplanerMitBudget, Betriebsleiter und Sachbearbeiter sollten die AG Kosten einsehen
			if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
				zeigePostenSummen(posten._id, postenSchichten, mitarbeiterAktiv);
				document.getElementById('tagessumme-ag-kosten-label').style.display = 'block';
			}
		}
		// Nur der DienstplanerMitBudget, Betriebsleiter und Sachbearbeiter sollten die AG Kosten einsehen
		if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
			const alleSchichtenBereich = alleSchichten.filter((s) => _.pluck(postenInBereich, '_id').includes(s.PostenID));
			zeigePostenSummen(-1, alleSchichtenBereich, mitarbeiterAktiv);
		}
		await zeigeWochenDaten();
		// Hier werden die Mitarbeiter Daten angezeigt pro Mitarbeiter pro Posten
		await zeigeMitarbeiter(mitarbeiterAktiv, qualifikationen, alleSchichten, schichtenPostenByMA);
		zeigeSchichtAddenControls();
		const auswahlBS = unternehmen.Betriebsstaette.find((bs) => bs._id === stammdatenService.aktuelleBetriebsstaette);
		await zeigeFeiertage(auswahlBS);
		gridContent.style.display = 'grid';
	} else {
		await SystemDialogService.instance.displayAsync('keine-bereiche-dialog');
	}
	document.body.style.cursor = 'default';
}

/**
 * Zeigt die Feiertage farblich im Dienstplan an.
 * @param {object} betriebsstaette
 */
async function zeigeFeiertage(betriebsstaette) {
	const feiertageBundesland = await datumService.fetchFeiertage(betriebsstaette.Bundesland, betriebsstaette.Feiertage);
	const datumStart = datumService.laufendesDatum;
	for (let i = 0; i < 7; i++) {
		const datumTmp = datumStart.add(i, 'days');
		const dateString = datumTmp.format('DD.MM.YYYY');
		const isFeiertag = feiertageBundesland[dateString];
		if (isFeiertag) {
			const gridItems = document.querySelectorAll(`[aria-label="${dateString}"]`);
			gridItems.forEach((item) => {
				item.classList.add('feiertag');
			});
			const datumHeader = document.getElementById(`date:${datumTmp.day() == 0 ? 7 : datumTmp.day()}`);
			const label = document.createElement('div');
			label.classList.add('feiertag-label');
			label.innerText = isFeiertag.fname;
			datumHeader.appendChild(label);
		}
	}
}

/**
 * Füllt das Schicht Vorlagen Select in der Toolbar mit Optionen.
 */
/**
 * Filter die mitarbeiter Liste nach Austrittsdatum
 * @param {array<object>} mitarbeiterliste
 * @returns aktive mitarbeiterliste
 */
function filterMitarbeiterAktiv(mitarbeiterliste) {
	const mitarbeiterAktiv = mitarbeiterliste.filter((ma) => {
		const beschaeftigung = ma.Beschaeftigung[0];
		// Falls es kein Eintrittsdatum wird der Mitarbeiter angezeigt (es macht keinen Sinn nur ein Austrittsdatum zu haben...)
		if (!beschaeftigung.Eintrittsdatum || beschaeftigung.Eintrittsdatum === '') {
			return true;
		}
		// falls es kein Austrittsdatum gibt, muss das Eintrittsdatum gleich oder vor dem laufendem Wochendatum sein...
		if (!beschaeftigung.Austrittsdatum || beschaeftigung.Austrittsdatum === '') {
			return datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD') >= beschaeftigung.Eintrittsdatum;
		}
		// Ansonsten ist der MA aktiv, falls das aktuelle Wochendatum zwischen Ein- und Austrittsdatum liegt.
		/**
		 * BSP:
		 * Woche 20.10. - 26.10.2025
		 * Eintritt 19.10.2025 <= 26.10.2025 y
		 * Eintritt 22.10.2025 <= 26.10.2025 y
		 * Austritt 22.10.2025 >= 20.10.2025 y
		 * Austritt 30.10.2025 >= 20.10.2025 y
		 * Austritt 17.10.2025 >= 20.10.2025 n
		 */
		return datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD') >= beschaeftigung.Eintrittsdatum && datumService.laufendesDatum.format('YYYY-MM-DD') <= beschaeftigung.Austrittsdatum;
	});
	return mitarbeiterAktiv;
}

async function erstelleToolbarVorlagenSelect() {
	const oldSelect = document.getElementById('vorlage-tb-select');
	if (oldSelect) {
		oldSelect.remove();
	}
	const vorlageSelect = await erstelleSchichtVorlageSelect(true);
	vorlageSelect.id = 'vorlage-tb-select';
	vorlageSelect.classList.add('toolbar-button');
	document.querySelector('#vorlage-neu').insertAdjacentElement('beforebegin', vorlageSelect);
}

/**
 * Erstellt Grid Header Zeilen für den bestimmten Posten
 * @param {array} postenListe Liste an Posten
 * @param {object} posten der Posten, der gerendert wird
 * @param {array<object>} mitarbeiter Liste an Mitarbeitern
 */
function zeigePostenZeilen(postenListe, posten, mitarbeiter, schichtenPostenByMA) {
	addHeaderRow(posten._id, postenListe);
	for (const m of mitarbeiter) {
		const aktivZugeordnet = m.Beschaeftigung[0].Posten.some((b) => b.PostenID === posten._id);
		const hatSchichten = schichtenPostenByMA.get(m._id)?.has(posten._id) ?? false;
		if (aktivZugeordnet || hatSchichten) {
			addGridRow(m._id, posten._id, datumService.laufendesDatum, m.Uebersicht.Wunschzeiten, m.Beschaeftigung[0].Urlaubsantraege, m.Beschaeftigung[0].Eintrittsdatum, m.Beschaeftigung[0].Austrittsdatum, m.Personalien?.Geburtsdatum);
		}
	}
}

/**
 * Gibt die Tagessummen des jeweiligen Postens an
 * - Für Bereichsumme folgendes als Parameter angeben:
 * ```
 * postenID = -1
 * ```
 * @param {string} postenID
 * @param {array<object>} postenSchichten
 * @param {array<object>} mitarbeiter
 */
function zeigePostenSummen(postenID, postenSchichten, mitarbeiter) {
	// Falls es die Zeile schon gibt, müssen wir sie nicht neu rendern...
	if (document.getElementById(`ma:${postenID}:-1`) === null) {
		addGridRow(-1, postenID, datumService.laufendesDatum);
	}
	document.getElementById(`ma:${postenID}:-1`).innerText = 'Tagessummen';
	const labelSpalte = document.getElementById(`ms:${postenID}:-1`);
	labelSpalte.style.justifyContent = 'end';
	labelSpalte.style.textAlign = 'end';
	labelSpalte.style.paddingRight = '10px';
	labelSpalte.innerText = 'Stunden\nAG-Kosten';
	let gesamtSumme = 0;
	let gesamtStunden = 0;
	for (let i = 1; i <= 7; i += 1) {
		let tagesSumme = 0;
		let tagesStunden = 0;
		const tagesSchichten = postenSchichten.filter((bs) => bs.Wochentag.Zahl === i);
		tagesSchichten.forEach((schicht) => {
			const arbeitszeit = schicht.BezahlteZeitGesamt;
			tagesStunden += schicht.BezahlteZeitGesamt;
			const ma = mitarbeiter.find((m) => m._id === schicht.MitarbeiterID);
			if (ma !== undefined) {
				const kosten = ma.Uebersicht.AGKostenProStunde;
				tagesSumme += arbeitszeit * kosten;
			}
		});
		const htmlID = `${i}:${postenID}:-1`;
		gesamtSumme += tagesSumme;
		gesamtStunden += tagesStunden;
		document.getElementById(htmlID).innerText = `${convertNumberDE(tagesStunden)} h\n${convertNumberToEuro(tagesSumme)}`;
	}
	document.getElementById(`ge:${postenID}:-1`).innerText = `${convertNumberDE(gesamtStunden)} h\n${convertNumberToEuro(gesamtSumme)}`;
}

/**
 * Zeigt die Mitarbeiter und dessen Qualifikationen in den ersten 2 Spalten an
 * @param {array} schichten
 * @param {array} mitarbeiter
 * @param {string} postenID
 */
async function zeigeMitarbeiter(mitarbeiter, qualifikationen, schichten, schichtenPostenByMA, postenID = undefined) {
	const maInfoTemplate = document.querySelector('[mitarbeiter-info-template]');
	for (const m of mitarbeiter) {
		const aktivePosIds = new Set(m.Beschaeftigung[0].Posten.map((p) => p.PostenID));
		const maPosten = schichtenPostenByMA.get(m._id) ?? new Set();
		const extraPosten = [...maPosten].filter((id) => !aktivePosIds.has(id)).map((id) => ({ PostenID: id }));
		const allePosten = [...m.Beschaeftigung[0].Posten, ...extraPosten];
		for (const p of allePosten) {
			// wenn wir nur einen Posten anzeigen wollen, überspringen wir alle anderen
			if (postenID !== p.PostenID && postenID) {
				continue;
			}
			// Fülle die Spalte Mitarbeiter mit Name und Qualifikationen
			let htmlID = `ma:${p.PostenID}:${m._id}`;
			const mitarbeiterElement = document.getElementById(htmlID);
			if (!mitarbeiterElement) {
				continue;
			}
			const mitarbeiterInfo = maInfoTemplate.content.cloneNode(true);
			const mitarbeteiterName = mitarbeiterInfo.querySelector('[mitarbeiter-name]');
			mitarbeteiterName.innerText = `${m.Personalien.Nachname}, ${m.Personalien.Vorname}`;
			const qualisAusblenden = await stammdatenService.getQualifikationenAusblenden();
			if (!qualisAusblenden) {
				const qualiElement = mitarbeiterInfo.querySelector('[mitarbeiter-qualifikationen]');
				// Wir können die Qualifikation(en) des Mitarbeiters aus dem Verguetungsfeld der Beschäftigung lesen.
				for (let j = 0; j < m.Beschaeftigung[0].Verguetung.length; j += 1) {
					// Nur verwendete Qualifikationen anzeigen
					if (m.Beschaeftigung[0].Verguetung[j].Verwenden) {
						const qualiStr = document.createElement('span');
						qualiStr.innerText = `${qualifikationen.find((q) => q._id === m.Beschaeftigung[0].Verguetung[j].QualifikationID).BezeichnungNeutral}\n`;
						qualiElement.appendChild(qualiStr);
					}
				}
			}
			const mitarbeiterCheckbox = mitarbeiterInfo.querySelector('[mitarbeiter-auswahl]');
			mitarbeiterCheckbox.setAttribute('aria-label', m._id);
			mitarbeiterCheckbox.setAttribute('aria-level', p.PostenID);
			mitarbeiterElement.appendChild(mitarbeiterInfo);
			// Fülle die Spalte Monatssumme mit Arbeitsstunden, Monatssoll, Überstunden,...
			htmlID = `ms:${p.PostenID}:${m._id}`;
			const monatElement = document.getElementById(htmlID);
			monatElement.classList.add('zeiten-ma');
			// Nur DienstplanerMitBudget, Betriebsleiter und Sachbearbeiter sehen die AG Kosten pro Stunde
			const urlaubsantraegeOffen = m.Beschaeftigung[0].Urlaubsantraege.some((ua) => dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).isBefore(ua.UrlaubBis) && ua.UrlaubStatus === 'offen');
			if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
				monatElement.innerHTML = `<div class="ma-status-grid">
						<div title="Ist- / Sollstunden"><i class="bi bi-clock-history"></i>&nbsp;${convertNumberDE(m.Uebersicht.StundenAktuell)}&nbsp;/&nbsp;${convertNumberDE(m.Beschaeftigung[0].SollstundenMonat)}h</div>
						<div title="Arbeitgeberkosten pro Stunde"><i class="bi bi-cash-coin"></i>&nbsp;${convertNumberToEuro(m.Uebersicht.AGKostenProStunde)}/h</div>
						<div title="Resturlaubstage/Urlaubsanträge"><i class="bi bi-airplane-fill ua-antrag-icon" style="transform: rotate(45deg);${urlaubsantraegeOffen ? 'color: var(--custom-yellow);' : ''}"></i>&nbsp;${m.Uebersicht.Resturlaub}d</div>
						<div title="Überstunden"><i class="bi bi-plus-slash-minus"></i>&nbsp;${convertNumberDE(m.Uebersicht.Ueberstunden)}h</div>
					</div>`;
			} else {
				monatElement.innerHTML = `<div class="ma-status-grid">
						<div title="Ist- / Sollstunden"><i class="bi bi-clock-history"></i>&nbsp;${convertNumberDE(m.Uebersicht.StundenAktuell)} / ${convertNumberDE(m.Beschaeftigung[0].SollstundenMonat)}h</div>
						<div title="Resturlaubstage"><i class="bi bi-airplane-fill ua-antrag-icon" style="transform: rotate(45deg);${urlaubsantraegeOffen ? 'color: var(--custom-yellow);' : ''}"></i>&nbsp;${m.Uebersicht.Resturlaub}d</div>
						<div title="Überstunden"><i class="bi bi-plus-slash-minus"></i>&nbsp;${convertNumberDE(m.Uebersicht.Ueberstunden)}h</div>
					</div>`;
			}
			if (
				window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
				window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
				window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
				window.myVars.UserRoles.includes(Roles.Zeitenpfleger)
			) {
				monatElement.addEventListener('click', () => ladeUrlaubsantraegeMA(m._id));
			} else {
				monatElement.addEventListener('click', () => zeigeKleineNachricht('Sie haben keine Berechtigung, die Urlaubsanträge einzusehen', 0));
			}
			zeigeMitarbeiterStunden(schichten, mitarbeiter, m._id, p.PostenID);
		}
	}
}

/**
 * Zeigt die Gesamtstunden des Mitarbeiters an
 * @param {array} schichten
 * @param {array} mitarbeiter
 * @param {string} mitarbeiterID
 * @param {string} postenID
 */
function zeigeMitarbeiterStunden(schichten, mitarbeiter, mitarbeiterID, postenID) {
	const mSchichten = filterSchichtenMitarbeiter(schichten, mitarbeiterID, postenID);
	let gesamtZeit = 0;
	const gesamtElem = document.getElementById(`ge:${postenID}:${mitarbeiterID}`);
	mSchichten.forEach((s) => {
		const schichtZeit = s.BezahlteZeitGesamt;
		gesamtZeit += schichtZeit;
	});
	if (!gesamtElem) return;
	// Dienstplaner Ohne Budget darf die AG Kosten nicht sehen
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
		gesamtElem.innerText = `${convertNumberDE(gesamtZeit)} h\n${convertNumberToEuro(gesamtZeit * mitarbeiter.find((m) => m._id === mitarbeiterID).Uebersicht.AGKostenProStunde)}`;
	} else {
		gesamtElem.innerText = `${convertNumberDE(gesamtZeit)} h\n`;
	}
}

/**
 * Zeigt alle Schichten an, der Default sind alle Schichten,
 * aber man kann auch eine beliebige Anzahl von Schichten auswählen, z.B. für den jeweiligen Posten
 * @param {array<object>} schichten
 * @param {object} posten
 */
function zeigeSchichten(schichten, posten, postenListe) {
	schichten.forEach((schicht) => {
		// ArbeitAmFeiertag entsteht durch Stempeln am Feiertag und wird im Dienstplan nicht angezeigt
		if (schicht.Zeitbloecke?.[0]?.EgfzID === Egfz.ArbeitAmFeiertag) return;
		const htmlID = `${schicht.Wochentag.Zahl}:${posten._id}:${schicht.MitarbeiterID}`;
		// zeige ein kleines Panel für Schichten in anderen Posten/Bereichen an
		if (schicht.PostenID !== posten._id) {
			createSchichtPanel(schicht, htmlID, postenListe);
			return;
		}
		createSchichtElement(schicht, htmlID);
	});
}
/**
 * Erstellt ein kleines Schicht Panel für das Anzeigen von geplanten Schichten außerhalb des Postens.
 * @param {object} schicht 
 * @param {string} gridId 
 */
function createSchichtPanel(schicht, gridId, postenListe) {
	// Die Grid Zelle, in der wir das Schichtpanel anzeigen wollen.
	const parent = document.getElementById(gridId);
	// wenn der Mitarbeiter nicht im Posten ist, überspringen wir die Schicht
	if (parent === null) {
		return;
	}
	const schichtPanel = schichtPanelTemplate.content.cloneNode(true).children[0];
	const schichtTitel = schichtPanel.querySelector('[schicht-titel]');
	const schichtInfo = schichtPanel.querySelector('[schicht-beschreibung]');
	const titel = secureHTML(schicht.Titel);
	let schichtBeschreibung = `${secureHTML(dayjs(schicht.SchichtVon).tz().format('HH:mm'))} - ${secureHTML(dayjs(schicht.SchichtBis).tz().format('HH:mm'))}`;
	if (!schicht.OffenesEnde && schicht.OffenerBeginn) {
		schichtBeschreibung = `bis ${secureHTML(dayjs(schicht.SchichtBis).tz().format('HH:mm'))}`;
	}
	if (schicht.OffenesEnde && !schicht.OffenerBeginn) {
		schichtBeschreibung = `ab ${secureHTML(dayjs(schicht.SchichtVon).tz().format('HH:mm'))}`;
	}
	if (schicht.OffenesEnde && schicht.OffenerBeginn) {
		schichtBeschreibung = 'offen';
	}
	schichtTitel.innerText = titel;
	schichtPanel.setAttribute('aria-label', schicht._id);
	const posten = findePosten(postenListe, schicht.PostenID);
	schichtPanel.title = `${schicht.Bereich ? `${schicht.Bereich}, ` : ''}${posten?.Posten || ''}: ${schichtBeschreibung}`;
	schichtInfo.innerText = `${schicht.Bereich ? `${schicht.Bereich}: ${schicht.ZeitTyp === 2 ? schichtBeschreibung : ''}` : `${schicht.ZeitTyp === 2 ? schichtBeschreibung : ''}` }`;
	// gridId of the shift's own Posten cell — may not be in DOM if that Bereich is disabled
	const schichtGridId = `${schicht.Wochentag.Zahl}:${schicht.PostenID}:${schicht.MitarbeiterID}`;
	const removeButton = schichtPanel.querySelector('[span-remove]');
	// Wenn der User Zugriff auf den Bereich der Schicht hat, aber die Schicht nicht in seinem Posten ist, soll er die Schicht entfernen können, da sie ja in seinem Bereich liegt. Ansonsten soll er die Schicht nicht entfernen können, da sie außerhalb seines Bereichs liegt.
	const isInUserBereich = window.myVars.UserBereiche.length === 0 || window.myVars.UserBereiche.includes(schicht.BereichID);
	if (!schicht.PostenID || _.isEmpty(posten) || isInUserBereich) {
		removeButton.setAttribute('onclick', `fun.schichtEntfernen("${schicht._id}", event, "${schichtGridId}")`);
	} else {
		removeButton.style.display = 'none';
	}
	parent.insertAdjacentElement('afterbegin', schichtPanel);

	// Unter Krank Panels keine Schicht Adden
	if ([Egfz.Krank, Egfz.KindKrank, Egfz.UnentschuldigtKrank].includes(schicht.Zeitbloecke[0].EgfzID)) {
		schichtPanel.classList.add('panel-krank');
		if (parent.querySelector('.span-add')) {
			parent.querySelector('.span-add').style.display = 'none';
		}
	}

	// entferne den Daumen hoch/runter falls eine Schicht eingefügt wurde
	parent.classList.add('wunschzeit-hide');
}

/**
 * Erstellt ein HTML Element aus dem Schicht Template
 * @param {object} schicht das SchichtOjekt
 * @param {*} gridId ID des HTML Grid Elements
 */
function createSchichtElement(schicht, gridId) {
	// Die Grid Zelle, in der wir die neue Schicht anzeigen wollen.
	const parent = document.getElementById(gridId);
	/**
	 * Falls wir kein Mitarbeiter Feld in diesem Posten finden aus irgendeinen Grund,
	 * z.B. hat der Mitarbeiter eine Schicht in diesem Posten, welche ihm nicht angehört,
	 * dann überspringen wir diesen...
	 */
	if (parent === null) {
		console.info('Diese Schicht hat keine Zuordnung, PostenID oder MitarbeiterID nicht mehr aktuell:', schicht._id);
		return;
	}
	const schichtElement = schichtDivTemplate.content.cloneNode(true).children[0];
	schichtElement.style.borderColor = schicht.SchichtFarbe ? schicht.SchichtFarbe : schichtElement.style.borderColor;
	const schichtTitel = schichtElement.querySelector('[schicht-titel]');
	const schichtBeschreibung = schichtElement.querySelector('[schicht-beschreibung]');
	const titel = secureHTML(schicht.Titel);
	const beschreibung = `${secureHTML(dayjs(schicht.SchichtVon).tz().format('HH:mm'))} - ${secureHTML(dayjs(schicht.SchichtBis).tz().format('HH:mm'))}`;
	schichtTitel.innerText = titel;
	schichtBeschreibung.innerText = beschreibung;
	const schichtID = schicht._id;
	schichtElement.ariaLabel = schichtID;
	// Falls die Schicht aktuell als Kopierquelle markiert ist, Markierung wieder anbringen
	// (z.B. nach Re-Render durch Wochen-/Bereich-/Betriebswechsel zurück zur Quellwoche).
	if (window.fun?.istKopierQuelleSchicht?.(String(schichtID))) {
		schichtElement.classList.add('schicht-kopier-quelle');
	}
	// Falls es sich um eine EGFZ Schicht handelt, werden wir kein Editieren erlauben, Löschen schon falls krank/schule Schicht
	if (schicht.ZeitTyp !== 2) {
		schichtElement.classList.add('egfz-schicht');
		// Nur bei Gutzeiten und Arbeit am FT interessiert uns hier die Uhrzeit...
		if (![Egfz.GZAufbau, Egfz.GZAbbau, Egfz.ArbeitAmFeiertag].includes(schicht.Zeitbloecke[0].EgfzID)) {
			schichtBeschreibung.style.display = 'none';
		}
		// Bei EGFZ Schichten verhalten sich die span tools etwas anders (nur Notiz bearbeiten und löschen)
		let egfzOptions = [Egfz.Krank, Egfz.KindKrank, Egfz.UnentschuldigtKrank, Egfz.Schule, Egfz.GZAbbau, Egfz.UnbezahltFrei, Egfz.Feiertag];
		const spanDiv = schichtElement.querySelector('[span-div]');
		spanDiv.style.display = 'flex';
		spanDiv.querySelector('[span-edit]').setAttribute('onclick', `fun.schichtNotizBearbeiten("${schichtID}", event, "${gridId}")`);
		spanDiv.querySelector('[span-edit]').title = 'Schichtnotiz hinzufügen';
		// Dienstplaner darf kein Urlaub löschen
		if (!window.myVars.UserRoles.includes(Roles.Dienstplaner)) {
			egfzOptions.push(Egfz.Urlaub);
		} else if (schicht.Zeitbloecke[0].EgfzID === Egfz.Urlaub) {
			spanDiv.querySelector('[span-remove]').style.display = 'none';
		}
		if (egfzOptions.includes(schicht.Zeitbloecke[0].EgfzID)) {
			spanDiv.querySelector('[span-remove]').setAttribute('onclick', `fun.schichtEntfernen("${schichtID}", event, "${gridId}")`);
			// Bei Krank keine weiteren Schichten anbieten
			if (parent.querySelector('.span-add')) {
				parent.querySelector('.span-add').style.display = 'none';
			}
		} 
		// Bei Urlaub wollen wir erst die Schicht, dann das Urlaubsicon
		parent.insertAdjacentElement('afterbegin', schichtElement);
	} else {
		// Freigabe icon anzeigen + Kopier-Markieren Icon darunter
		const schichtFreigabeStatus = schichtElement.querySelector('[schicht-freigabe-status]');
		const freigabeIcon = schicht.SchichtFreigabe
			? '<i class="bi bi-circle-fill" title="Schicht freigegeben"></i>'
			: '<i class="bi bi-circle" title="Schicht noch nicht freigegeben"></i>';
		schichtFreigabeStatus.innerHTML = `${freigabeIcon}<span class="span-tools schicht-kopier-icon hidden-print" title="Schicht zum Kopieren markieren"><i class="bi bi-copy"></i></span>`;
		schichtFreigabeStatus.querySelector('.schicht-kopier-icon').addEventListener('click', (event) => {
			event.stopPropagation();
			window.fun?.markiereKopierQuelle?.(schichtID, schichtElement);
		});
		// Posten als aria Attribut speichern
		schichtElement.setAttribute('aria-description', schicht.PostenID);
		// Event Listener einbauen
		schichtElement.setAttribute('onclick', `fun.schichtEditieren("${schichtID}", event, "${gridId}")`);
		const spanDiv = schichtElement.querySelector('[span-div]');
		spanDiv.querySelector('[span-edit]').setAttribute('onclick', `fun.schichtEditieren("${schichtID}", event, "${gridId}")`);
		spanDiv.querySelector('[span-remove]').setAttribute('onclick', `fun.schichtEntfernen("${schichtID}", event, "${gridId}")`);
		if (!schicht.OffenesEnde && schicht.OffenerBeginn) {
			schichtBeschreibung.innerText = `bis ${secureHTML(dayjs(schicht.SchichtBis).tz().format('HH:mm'))}`;
		}
		if (schicht.OffenesEnde && !schicht.OffenerBeginn) {
			schichtBeschreibung.innerText = `ab ${secureHTML(dayjs(schicht.SchichtVon).tz().format('HH:mm'))}`;
		}
		if (schicht.OffenesEnde && schicht.OffenerBeginn) {
			schichtBeschreibung.innerText = '';
		}
		if (parent.querySelector('.span-add')) {
			parent.querySelector('.span-add').insertAdjacentElement('beforebegin', schichtElement);
		} else {
			parent.appendChild(schichtElement);
		}
	}
	
	// entferne den Daumen hoch/runter falls eine Schicht eingefügt wurde
	parent.classList.add('wunschzeit-hide');
}

/**
 * Zeige die Schicht Hinzufügen Controls, wenn es in dem Feld keine Schicht gibt.
 * - wir blenden es aus mit style: none, falls es eine schicht gibt.
 */
function zeigeSchichtAddenControls() {
	const gridItems = document.getElementsByClassName('tag');
	Array.from(gridItems).forEach((tagDiv) => {
		if (tagDiv.id.split(':')[2] !== '-1' && !['ma', 'ms', 'ge'].includes(tagDiv.id.split(':')[0])) {
			const addButton = schichtAddenTemplate.content.cloneNode(true).children[0];
			tagDiv.appendChild(addButton);
			// Falls der Mitarbeiter an dem Tag nicht arbeitet, verhindern wir die Schicht Hinzufügen Funktion
			if (tagDiv.classList.contains('ma-inaktiv')) {
				addButton.style.opacity = '0.2';
				addButton.style.cursor = 'not-allowed';
				addButton.setAttribute('onclick', 'fun.zeigeNachricht(\'Datum liegt außerhalb des Beschäftigungzeitraums!\', 0)');
				return;
			}
			addButton.setAttribute('onclick', `fun.schichtAdden("${tagDiv.id}")`);
			// Bei EGFZ Schichten, Krank oder Urlaub kann der Mitarbeiter keine Weitere Schicht haben
			if (tagDiv.querySelector('.egfz-schicht') || tagDiv.querySelector('.panel-krank') || tagDiv.querySelector('.tag-urlaub')) {
				addButton.style.display = 'none';
			}
		}
	});
}

/**
 * Bestückt die Kalenderwochen- und Datumszeile mit aktuellen Daten
 */
async function zeigeWochenDaten() {
	// Datum und KW anzeigen
	datumService.holeWochenDaten().forEach((tag) => {
		document.getElementById(`date:${tag.day() === 0 ? 7 : tag.day()}`).innerText = `${tag.format('dd.')} ${tag.format('DD.MM.')}`;
	});
	const inputWeek = document.getElementById('kal-woche');
	inputWeek.innerHTML = `KW ${datumService.kalenderWoche} (${datumService.laufendesDatum.endOf('week').year()}) <i class="bi bi-calendar-week"></i>`;
	// Notiz Input Felder zurücksetzen und ausfüllen
	const inputFelder = document.querySelectorAll('.tages-notiz');
	inputFelder.forEach((input) => { input.value = ''; });
	const dpNotizen = await stammdatenService.getTagesnotizenWoche(datumService.laufendesDatum.startOf('week').format('YYYY-MM-DD'), datumService.laufendesDatum.endOf('week').format('YYYY-MM-DD'), stammdatenService.aktuelleBetriebsstaette);
	dpNotizen.forEach((notiz) => {
		// Sonntag ist bei uns der 7. Tag.
		const tagIndex = dayjs(notiz.Datum).tz().day() === 0 ? 7 : dayjs(notiz.Datum).tz().day();
		const notizfeld = document.getElementById(`notiz:${tagIndex}`).querySelector('textarea');
		notizfeld.value = notiz.Notiz;
	});
}

/**
 * Erstellt ein HTML Select Element zur Qualifikationsauswahl
 * @param {array} qualisMA
 * @param {string} QualifikationID beim Editieren, die bereits eingetragene Qualifikation
 * @returns HTML Select Element
 */
 async function erstelleQualifikationSelect(qualifikationen, qualisMA, QualifikationID = undefined) {
	const select = document.createElement('select');
	select.id = 'input-qualifikation';
	select.className = 'input-item';
	// forEach loop does not work correctly with async/await here
	qualisMA.forEach((q) => {
		if (!q.Verwenden) return;
		const newOption = document.createElement('option');
		newOption.setAttribute('value', q.QualifikationID);
		newOption.innerText = findeQualifikation(qualifikationen, q.QualifikationID).BezeichnungNeutral;
		select.appendChild(newOption);
	});
	if (QualifikationID) select.value = QualifikationID;
	return select;
}

/**
 * Erstellt ein HTML Select Element des aktuellen Postens
 * @param {array<object>} postenListe
 * @param {string} postenID die ID des aktuellen Postens
 * @returns HTML Select Element
 */
async function erstellePostenSelect(postenListe, postenID) {
	const select = document.createElement('select');
	select.id = 'input-posten-select';
	select.className = 'input-item';
	// Entweder zeigen wir nur den aktuellen Posten an oder ein Select mit allen.
	if (!postenID) {
		postenListe.forEach((b) => {
			const newOption = document.createElement('option');
			newOption.setAttribute('value', b._id);
			newOption.innerText = b.Posten;
			select.appendChild(newOption);
		});
	} else {
		const posten = findePosten(postenListe, postenID);
		select.setAttribute('disabled', '');
		const option = document.createElement('option');
		option.value = posten._id;
		option.innerText = posten.Posten;
		select.appendChild(option);
	}
	return select;
}

/**
 * Erstellt ein Select Feld mit den Schichtvorlagen
 * @param {boolean} isToolbar Flag ob das Select für die Toolbar oder Schicht Editor erstellt werden soll
 * @param {Number} isEditSchicht Flag ob das Select im Schicht Editiermodus ist
 */
async function erstelleSchichtVorlageSelect(isToolbar = false, isEditSchicht = false) {
	// Reset falls schon da gewesen, z.B. beim Bereichwechsel oder Speichern von neuen Schichtvorlagen
	if (document.getElementById('input-vorlage') !== null) {
		document.getElementById('input-vorlage').remove();
	}
	const bereichID = document.getElementById('bereich-select').value;
	const vorlagen = await schichtenService.holeSchichtVorlagen(bereichID);
	vorlagen.sort((a, b) => a.Titel.localeCompare(b.Titel)); // alphabetisch sortieren
	vorlagen.sort((a, b) => new Date(a.SchichtVon) - new Date(b.SchichtVon)); // nach Schichtbeginn sortieren
	vorlagen.sort((a, b) => Number(a.OffenerBeginn) - Number(b.OffenerBeginn)); // Offener Beginn ans Ende der Liste sortieren
	vorlagen.sort((a, b) => customCompareBoolean(a, b)); // Schichten mit offenen Beginn und Ende ans Ende der Liste sortieren
	const select = document.createElement('select');
	select.id = 'input-vorlage';
	select.className = 'input-item';
	// Leere Option anbieten...
	const emptyOption = document.createElement('option');
	emptyOption.setAttribute('value', '');
	emptyOption.innerText = isToolbar || isEditSchicht ? 'Schichtvorlage wählen' : 'Neue Schichtvorlage';
	select.append(emptyOption);
	// Schichtvorlagen Optionen anbieten...
	const optgroupVorlage = erstelleVorlagenOptgroup(vorlagen);
	select.appendChild(optgroupVorlage);
	// Weitere EGFZ Optionen anbieten in der Toolbar...
	if (isToolbar) {
		const optgroupEGFZ = erstelleEGFZOptgroup();
		select.appendChild(optgroupEGFZ);
		select.addEventListener('change', (event) => changeVorlageActive(select.value, event));
	}

	// Wir brauchen den EventListener nicht für die Toolbar
	if (!isToolbar) {
		select.addEventListener('change', () => {
			// Schicht Werte laden
			const auswahl = vorlagen.find((s) => s._id === select.value);
			if (auswahl !== undefined) {
				// Übernehmen der Attribute aus der ausgewählten Vorlage...
				const titelInput = document.getElementById('input-titel');
				const offenesEndeCheck = document.getElementById('input-schicht-offenes-ende');
				offenesEndeCheck.checked = auswahl.OffenesEnde;
				const offenerBeginnCheck = document.getElementById('input-schicht-offener-beginn');
				offenerBeginnCheck.checked = auswahl.OffenerBeginn;
				document.querySelector('#input-schicht-farbe').value = auswahl.SchichtFarbe ? auswahl.SchichtFarbe : '#0071bd';
				document.querySelector('#input-schicht-notiz').value = auswahl.SchichtNotiz ? auswahl.SchichtNotiz : '';
				titelInput.querySelector('input').value = auswahl.Titel;
				erstelleZeitblockTabelle(auswahl, 0);
			}
		});
	}

	if (isToolbar) {
		// wir brauchen auch die buttons für die übersicht
		erstelleVorlagenButtonsSidebar(vorlagen);
	}
	return select;
}

function erstelleVorlagenButtonsSidebar(vorlagen) {
	const vorlagenListe = document.getElementById('vorlagen-liste');
	vorlagenListe.innerHTML = '';
	const bereich = document.getElementById('bereich-select').selectedOptions[0].innerText;
	document.getElementById('vorlagen-liste-bereich').innerText = bereich;
	let egfzOptions = [
		{ EgfzID: Egfz.Krank, Bezeichnung: 'Krank', Titel: 'Krank' },
		{ EgfzID: Egfz.UnentschuldigtKrank, Bezeichnung: 'unentschuldigt krank', Titel: 'unentschuldigt Krank' },
		{ EgfzID: Egfz.KindKrank, Bezeichnung: 'Kind krank', Titel: 'kind Krank' },
		{ EgfzID: Egfz.Schule, Bezeichnung: 'Schule', Titel: 'Schule' },
		{ EgfzID: Egfz.GZAbbau, Bezeichnung: 'GZ-', Titel: 'Gutzeit Abbau' },
		{ EgfzID: Egfz.UnbezahltFrei, Bezeichnung: 'Frei', Titel: 'unbezahlt frei' },
		{ EgfzID: Egfz.Feiertag, Bezeichnung: 'Feiertag frei', Titel: 'Feiertag' }
	];
	// Nur Dienstplaner Rolle darf keine Urlaube anlegen, alle anderen Rollen schon
	if (
		window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
		window.myVars.UserRoles.includes(Roles.Zeitenpfleger)
 	) {
		egfzOptions.push({
		EgfzID: Egfz.Urlaub,
		Bezeichnung: 'Urlaub',
		Titel: 'Urlaub',
		});
 	}
	egfzOptions.forEach((egfzKrank) => {
		const schichtElement = schichtDivTemplate.content.cloneNode(true).children[0];
		const schichtTitel = schichtElement.querySelector('[schicht-titel]');
		schichtElement.classList.add('egfz-schicht');
		schichtElement.style.cursor = 'pointer';
		schichtElement.setAttribute('aria-label', egfzKrank.EgfzID);
		schichtTitel.innerText = egfzKrank.Bezeichnung;
		schichtElement.title = egfzKrank.Titel;
		schichtElement.querySelector('.span-div').style.display = 'none';
		schichtElement.addEventListener('click', (event) => changeVorlageActive(egfzKrank.EgfzID, event));
		vorlagenListe.appendChild(schichtElement);
	});
	vorlagen.forEach((vorlage) => {
		const schichtElement = schichtDivTemplate.content.cloneNode(true).children[0];
		schichtElement.style.borderColor = vorlage.SchichtFarbe ? vorlage.SchichtFarbe : schichtElement.style.borderColor;
		const schichtTitel = schichtElement.querySelector('[schicht-titel]');
		const schichtBeschreibung = schichtElement.querySelector('[schicht-beschreibung]');
		const titel = secureHTML(vorlage.Titel);
		let beschreibung = `${secureHTML(dayjs(vorlage.SchichtVon).tz().format('HH:mm'))} - ${secureHTML(dayjs(vorlage.SchichtBis).tz().format('HH:mm'))}`;
		if (!vorlage.OffenesEnde && vorlage.OffenerBeginn) {
			beschreibung = `bis ${secureHTML(dayjs(vorlage.SchichtBis).tz().format('HH:mm'))}`;
		}
		if (vorlage.OffenesEnde && !vorlage.OffenerBeginn) {
			beschreibung = `ab ${secureHTML(dayjs(vorlage.SchichtVon).tz().format('HH:mm'))}`;
		}
		if (vorlage.OffenesEnde && vorlage.OffenerBeginn) {
			beschreibung = '';
		}
		schichtTitel.innerText = titel;
		schichtBeschreibung.innerText = beschreibung;
		const vorlageID = vorlage._id;
		schichtElement.setAttribute('aria-label', vorlageID);
		schichtElement.classList.add('vorlagen-liste-item');
		vorlagenListe.appendChild(schichtElement);
		schichtElement.addEventListener('click', (event) => changeVorlageActive(vorlageID, event));
		schichtElement.querySelector('[span-edit]').addEventListener('click', (event) => {
			window.tb.erstelleSchichtVorlagenInputFeld(vorlageID);
		});
		schichtElement.querySelector('[span-remove]').style.display = 'none';
	});
	
}

/**
 * Wählt eine Vorlage aus der Sidebar aus und markiert diese.
 * Bei erneuten Klick auf die selbe wird die Auswahl aufgehoben.
 * @param {string} vorlageID die ausgewählte VorlagenID
 */
function changeVorlageActive(vorlageID, event) {
	// Alle Markierungen aufheben...
	const vorlagenListe = document.getElementById('vorlagen-liste');
	[...vorlagenListe.querySelectorAll('.vorlage-liste-item-active')].forEach((vl) => vl.classList.remove('vorlage-liste-item-active'));
	// Input mit altem Input vergleichen, ggfs abwählen bei erneuten Klick auf die gleiche Vorlage.
	const vorlageSelect = document.getElementById('vorlage-tb-select');
	// Im Select Event ist vorlageID und select.value immer gleich, hier müssen wir unterscheiden zwischen Select und Sidebar... 
	// ... und bei Klick auf Edit Vorlage nicht abwählen, da sonst der Vorlagen Editor keine Vorlage erhält
	if ((vorlageID == vorlageSelect.value && event.type !== 'change' && event.target.tagName !== 'I')) {
        vorlageSelect.value = '';
        return;
    }
	// Wenn es sich um eine andere Vorlage handelt, markieren wir diese.
	if (vorlageID != '') {
		vorlageSelect.value = vorlageID;
		const vorlage = vorlagenListe.querySelector(`[aria-label="${vorlageID}"]`);
		vorlage.classList.add('vorlage-liste-item-active');
	}
}

// Custom comparison function
function customCompareBoolean(a, b) {
	if (a.OffenerBeginn === true && a.OffenesEnde === true && (b.OffenerBeginn !== true || b.OffenesEnde !== true)) {
	  return 1; // a comes after b
	} else if (b.OffenerBeginn === true && b.OffenesEnde === true && (a.OffenerBeginn !== true || a.OffenesEnde !== true)) {
	  return -1; // b comes after a
	} else {
	  return 0; // No change in order
	}
  }

function erstelleVorlagenOptgroup(schichten) {
	const optgroupVorlage = document.createElement('optgroup');
	optgroupVorlage.label = 'Schichtvorlagen';
	schichten.forEach((schicht) => {
		const newOption = document.createElement('option');
		newOption.id = schicht._id;
		newOption.setAttribute('value', schicht._id);
		newOption.innerText = `${schicht.Titel}, `
			+ `${dayjs(schicht.SchichtVon).tz().format('HH:mm')} - ${dayjs(schicht.SchichtBis).tz().format('HH:mm')}`;
		// offenes Ende
		if (schicht.OffenesEnde && !schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}, `
			+ `ab ${dayjs(schicht.SchichtVon).tz().format('HH:mm')}`;
		}
		// offener Beginn
		if (!schicht.OffenesEnde && schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}, `
			+ `bis ${dayjs(schicht.SchichtBis).tz().format('HH:mm')}`;
		}
		// offener Beginn und Ende
		if (schicht.OffenesEnde && schicht.OffenerBeginn) {
			newOption.innerText = `${schicht.Titel}`;
		}
		optgroupVorlage.appendChild(newOption);
	});
	return optgroupVorlage;
}

function erstelleEGFZOptgroup() {
	const optgroupEGFZ = document.createElement('optgroup');
	optgroupEGFZ.label = 'Krank einfügen';
	let egfzOptions = [
		{ EgfzID: Egfz.Krank, Bezeichnung: 'Krank' },
		{ EgfzID: Egfz.UnentschuldigtKrank, Bezeichnung: 'unentschuldigt krank' },
		{ EgfzID: Egfz.KindKrank, Bezeichnung: 'Kind krank' },
		{ EgfzID: Egfz.Schule, Bezeichnung: 'Schule' },
		{ EgfzID: Egfz.GZAbbau, Bezeichnung: 'GZ-' },
		{ EgfzID: Egfz.UnbezahltFrei, Bezeichnung: 'Frei' },
		{ EgfzID: Egfz.Feiertag, Bezeichnung: 'Feiertag frei' }
	];
	// Nur Dienstplaner Rolle darf keine Urlaube anlegen, alle anderen Rollen schon
	if (
		window.myVars.UserRoles.includes(Roles.Sachbearbeiter) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget) ||
		window.myVars.UserRoles.includes(Roles.DienstplanerOhneBudget) ||
		window.myVars.UserRoles.includes(Roles.Zeitenpfleger)
 	) {
		egfzOptions.push({ EgfzID: Egfz.Urlaub, Bezeichnung: 'Urlaub' });
	}
	egfzOptions.forEach((egfzKrank) => {
		const newOption = document.createElement('option');
		newOption.setAttribute('value', egfzKrank.EgfzID);
		newOption.innerText = egfzKrank.Bezeichnung;
		optgroupEGFZ.appendChild(newOption);
	});
	return optgroupEGFZ;
}

/**
 * Zeigt die neue Schicht im Dienstplan an (und ersetzt ggf. die alte Schicht).
 * @param {object} schichtObjekt
 * @param {string} gridId
 */
async function zeigeNeueSchicht(schichtObjekt, gridId) {
	const oldElement = document.querySelector(`[aria-label="${schichtObjekt._id}"]`);
	// Falls es ein altes Element mit der gleichen ID gibt, dann müssen wir dieses aus der Oberfläche entfernen...
	if (oldElement !== null) {
		oldElement.remove();
	}
	// ArbeitAmFeiertag entsteht durch Stempeln am Feiertag und wird im Dienstplan nicht angezeigt
	if (schichtObjekt.Zeitbloecke?.[0]?.EgfzID === Egfz.ArbeitAmFeiertag) return;
	createSchichtElement(schichtObjekt, gridId);
	await updateSummenZeilen(schichtObjekt);
	// schicht panels anzeigen in anderen Posten.
	const postenListe = await stammdatenService.getPosten();
	const bereichAuswahl = document.getElementById('bereich-select').value;
	const postenInBereich = postenListe.filter((p) => _.isEqual(p.BereichID, bereichAuswahl));
	postenInBereich.forEach((posten) => {
		if (!_.isEqual(posten._id, schichtObjekt.PostenID)) {
			const panelGridID = `${gridId.split(':')[0]}:${posten._id}:${gridId.split(':')[2]}`;
			createSchichtPanel(schichtObjekt, panelGridID, postenInBereich);
		}
	});
}

/**
 * Entferne ein schicht Element aus dem Grid und stellt, falls leer, das SchichtAdden Element wieder her.
 * @param {object} schichtObjekt
 * @param {string} gridId
 */
async function entferneSchichtElement(schichtObjekt, gridId) {
	const gridElement = document.getElementById(gridId);
	// gridElement kann fehlen wenn der Posten zu einem deaktivierten Bereich gehört
	if (gridElement) {
		gridElement.querySelector(`[aria-label="${schichtObjekt._id}"]`)?.remove();
		gridElement.classList.remove('wunschzeit-hide');
		if (gridElement.querySelector('.span-add')) {
			gridElement.querySelector('.span-add').style.display = 'block';
		}
	}
	await updateSummenZeilen(schichtObjekt);
	document.querySelectorAll(`.schicht-panel[aria-label="${schichtObjekt._id}"]`).forEach((elem) => elem.remove());
}

/**
 * Aktualisiert die jeweiligen Summen Zeilen nach Änderung eines Schicht Objekts.
 * @param {object} schichtObjekt
 */
async function updateSummenZeilen(schichtObjekt) {
	// Berechne Wochensummen und Tagessummen neu...
	const bereichAuswahl = document.getElementById('bereich-select').value;
	const schichten = await schichtenService.getSchichten(datumService.laufendesDatum, bereichAuswahl);
	const mitarbeiter = await stammdatenService.getMitarbeiter();
	zeigeMitarbeiterStunden(schichten, mitarbeiter, schichtObjekt.MitarbeiterID, schichtObjekt.PostenID);
	if (window.myVars.UserRoles.includes(Roles.Sachbearbeiter) || window.myVars.UserRoles.includes(Roles.DienstplanerMitBudget)) {
		const postenSchichten = schichten.filter((s) => s.PostenID === schichtObjekt.PostenID);
		zeigePostenSummen(schichtObjekt.PostenID, postenSchichten, mitarbeiter);
		zeigePostenSummen(-1, schichten, mitarbeiter);
	}
}


/**
 * Ladet die Urlaubswerte und -anträge in die Oberfläche
 * @param {object} aktuellerMA
 */
async function ladeUrlaubsantraegeMA(maAuswahl) {
    const mitarbeiterliste = await stammdatenService.getMitarbeiter(true);
    let aktuellerMA = mitarbeiterliste.find((ma) => ma._id === maAuswahl);
    const urlaubsdialog = document.getElementById('urlaubsantrag-dialog');
    urlaubsdialog.querySelector('#ma-urlaub-name').innerText = `${aktuellerMA.Personalien.Vorname} ${aktuellerMA.Personalien.Nachname}`;
    const aktuelleBeschaeftigung = aktuellerMA.Beschaeftigung[0];
    const antragListe = urlaubsdialog.querySelector('.ma-ua-liste');
    antragListe.innerHTML = '';
    const antragTemplate = urlaubsdialog.querySelector('[ma-ua-template]');
    const urlaubsantraegeAktuell = aktuelleBeschaeftigung.Urlaubsantraege.filter((ua) => dayjs.tz(new Date(), dayjs.tz.DEFAULT_TZ).startOf('week').isBefore(ua.UrlaubBis));
    if (urlaubsantraegeAktuell.length <= 0) {
        antragListe.innerHTML = 'keine aktuellen Urlaubsanträge vorhanden.';
    }
    urlaubsantraegeAktuell.forEach((antrag) => {
        const newRow = antragTemplate.content.cloneNode(true).children[0];
        newRow.querySelector('[aria-label="ma-ua-UrlaubVon"]').innerText = dayjs(antrag.UrlaubVon).tz().format('DD.MM.YY');
        newRow.querySelector('[aria-label="ma-ua-UrlaubBis"]').innerText = dayjs(antrag.UrlaubBis).tz().format('DD.MM.YY');
        newRow.querySelector('[aria-label="ma-ua-AnzahlEGFZTage"]').innerText = antrag.AnzahlEGFZTage;
        newRow.querySelector('[aria-label="ma-ua-UrlaubStatus"]').innerText = antrag.UrlaubStatus;
        newRow.querySelector('.ua-genehmigen').addEventListener('click', () => updateUrlaubsantragMA(antrag, newRow, 'genehmigt', aktuellerMA));
        newRow.querySelector('.ua-ablehnen').addEventListener('click', () => updateUrlaubsantragMA(antrag, newRow, 'abgelehnt', aktuellerMA));
        antragListe.appendChild(newRow);
    });
    await SystemDialogService.instance.displayAsync('urlaubsantrag-dialog');
}

/**
 * Updated den Urlaubsantragsstatus, je nach dem welche Aktion ausgeführt wurde
 * @param {HTMLElement} thisElement Urlaub antrag akzeptieren/ablehnen/reset button
 * @param {string} statusUpdate abgelehnt, offen, genehmigt
 */
async function updateUrlaubsantragMA(urlaubsantrag, urlaubsantragHTML, statusUpdate, aktuellerMA) {
    const urlaubStatus = urlaubsantragHTML.querySelector('[aria-label="ma-ua-UrlaubStatus"]');
    if (urlaubStatus.innerText === statusUpdate) {
        zeigeKleineNachricht(`Der Status des Urlaubantrags ist bereits ${statusUpdate}!`);
        return false;
    }
    // Hier müssten vor dem Speichervorgang die Urlaubstage als Schichten ein oder ausgetragen werden...
    if (urlaubsantrag.UrlaubStatus !== 'genehmigt' && statusUpdate === 'genehmigt') {
        const result = await schichtenService.erstelleUrlaubAusAntrag(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
		if (result) {
			SystemDialogService.instance.confirm();
			await zeigeDienstplan(true, false, false, true);
		}
        return true;
    }
    // Wenn wir einen genehmigten/offenen Urlaubseintrag ablehnen, müssen wir die Urlaubstage austragen.
    if ((urlaubsantrag.UrlaubStatus === 'offen' || urlaubsantrag.UrlaubStatus === 'genehmigt') && statusUpdate === 'abgelehnt') {
        await schichtenService.entferneUrlaub(aktuellerMA._id, urlaubsantrag._id, statusUpdate);
        // aktualisiere und speichere urlaubsantragstatus
		await zeigeDienstplan(true, false, false, true);
		SystemDialogService.instance.confirm();
        return true;
    }
}

export {
	zeigeDienstplan,
	erstellePostenSelect,
	erstelleQualifikationSelect,
	erstelleSchichtVorlageSelect,
	zeigeNeueSchicht,
	entferneSchichtElement,
	erstelleToolbarVorlagenSelect,
	ladeUrlaubsantraegeMA
};
